export interface IUser {
	id?: number;
	username?: string;
	name?: string;
	first_name?: string;
	nickname?: string;
	slug?: string;
	last_name?: string;
	email?: string;
	url?: string;
	description?: string;
	password?: string;
}
